module.exports = __webpack_public_path__ + "static/media/fabio.5c1c1315.jpg";